// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1InvV","detailsBorder":"styles_detailsBorder__1XKqs"};